/* =========================================================================
   Page « Votre avis » · Laboratoire Hollis · v2.2 (14/10/2026)
   -------------------------------------------------------------------------
   Multi-produits : une carte par produit de la commande, dans l'ordre de la
   commande. Publication produit par produit vers Stamped (via l'App Proxy).
   Étape 2 (réponses privées) : uniquement après l'avis 9 Mois / Post-Partum,
   et uniquement si le réglage « Activer l'étape 2 » est coché.


   WORDING : validé (bible « Votre avis » + maquette validée par Tatiana le
   14/10/2026, codes NV-xx listés dans README_INTEGRATION.md §9). Ne rien reformuler.
   ========================================================================= */
(function () {
  'use strict';


  /* ===================== 1 · GÉNÉRATEUR D'AVIS ===================== */
  /* @@GEN-START — injecté depuis generateur.js par build.py (source unique, identique à la maquette). Ne pas éditer ici. */


var A3DEF = {
  label: 'Cette évolution, vous l’avez ressentie…',
  opts: [
    ['Assez vite', 'vite'],
    ['Petit à petit', 'progressif'],
    ['Je commence tout juste à le sentir', 'debut']
  ]
};


var APPR = {
  label: 'Ce que vous avez apprécié',
  help: 'Facultatif · Vous pouvez choisir plusieurs réponses pour enrichir votre avis.',
  opts: [
    ['La prise facile au quotidien', 'prise'],
    ['La composition', 'composition'],
    ['La fabrication française', 'france'],
    ['Me sentir accompagnée', 'accompagnee'],
    ['Je le recommande', 'reco']
  ]
};


var FRAG = {
  prise: 'la prise facile au quotidien',
  composition: 'la composition',
  france: 'la fabrication française'
};


var A2DEF = {
  pp: {
    label: 'Depuis que vous prenez Post-Partum, qu’avez-vous surtout remarqué du côté de votre énergie et de votre équilibre émotionnel ?',
    opts: [
      ['Mon énergie physique', 'energie'],
      ['Mon équilibre émotionnel', 'emotion'],
      ['Les deux', 'deux'],
      ['Pas de changement remarqué', 'aucun']
    ]
  },
  m9: {
    label: 'Depuis que vous prenez 9 Mois, qu’avez-vous surtout remarqué dans votre bien-être au quotidien ?',
    opts: [
      ['Mon énergie au quotidien', 'energie'],
      ['La régularité de mon énergie', 'regularite'],
      ['Les deux', 'deux'],
      ['Pas de changement remarqué', 'aucun']
    ]
  }
};


var BASES = {
  pp: {
    'aucun': 'Depuis que je prends Post-Partum, je n’ai pas remarqué de changement particulier.',
    'energie|progressif': 'Depuis que je prends Post-Partum, j’ai remarqué une évolution progressive de mon énergie physique.',
    'emotion|progressif': 'Depuis que je prends Post-Partum, j’ai remarqué que mon équilibre émotionnel évoluait progressivement.',
    'deux|progressif': 'Depuis que je prends Post-Partum, j’ai remarqué des changements progressifs, aussi bien dans mon énergie physique que dans mon équilibre émotionnel.',
    'energie|vite': 'Depuis que je prends Post-Partum, j’ai assez vite remarqué une évolution de mon énergie physique.',
    'emotion|vite': 'Depuis que je prends Post-Partum, j’ai assez vite remarqué que mon équilibre émotionnel évoluait.',
    'deux|vite': 'Depuis que je prends Post-Partum, j’ai assez vite remarqué des changements, aussi bien dans mon énergie physique que dans mon équilibre émotionnel.',
    'energie|debut': 'Depuis que je prends Post-Partum, je commence seulement à remarquer des changements dans mon énergie physique.',
    'emotion|debut': 'Depuis que je prends Post-Partum, je commence tout juste à remarquer une évolution de mon équilibre émotionnel.',
    'deux|debut': 'Depuis que je prends Post-Partum, je commence tout juste à remarquer des changements, aussi bien dans mon énergie physique que dans mon équilibre émotionnel.',
    'energie': 'Depuis que je prends Post-Partum, j’ai remarqué une évolution de mon énergie physique.',
    'emotion': 'Depuis que je prends Post-Partum, j’ai remarqué que mon équilibre émotionnel évoluait.',
    'deux': 'Depuis que je prends Post-Partum, j’ai remarqué des changements, aussi bien dans mon énergie physique que dans mon équilibre émotionnel.'
  },
  m9: {
    'aucun': 'Depuis que je prends 9 Mois, je n’ai pas remarqué de changement particulier dans mon bien-être au quotidien.',
    'energie|vite': 'Depuis que je prends 9 Mois, j’ai assez vite remarqué des changements dans mon énergie au quotidien.',
    'energie|progressif': 'Depuis que je prends 9 Mois, j’ai remarqué des changements progressifs dans mon énergie au quotidien.',
    'energie|debut': 'Depuis que je prends 9 Mois, je commence tout juste à remarquer des changements dans mon énergie au quotidien.',
    'regularite|vite': 'Depuis que je prends 9 Mois, j’ai assez vite remarqué une évolution dans la régularité de mon énergie.',
    'regularite|progressif': 'Depuis que je prends 9 Mois, j’ai remarqué une évolution progressive dans la régularité de mon énergie.',
    'regularite|debut': 'Depuis que je prends 9 Mois, je commence tout juste à remarquer une évolution dans la régularité de mon énergie.',
    'deux|vite': 'Depuis que je prends 9 Mois, j’ai assez vite remarqué des changements dans mon énergie au quotidien et dans sa régularité.',
    'deux|progressif': 'Depuis que je prends 9 Mois, j’ai remarqué des changements progressifs dans mon énergie au quotidien et dans sa régularité.',
    'deux|debut': 'Depuis que je prends 9 Mois, je commence tout juste à remarquer des changements dans mon énergie au quotidien et dans sa régularité.',
    'energie': 'Depuis que je prends 9 Mois, j’ai remarqué des changements dans mon énergie au quotidien.',
    'regularite': 'Depuis que je prends 9 Mois, j’ai remarqué une évolution dans la régularité de mon énergie.',
    'deux': 'Depuis que je prends 9 Mois, j’ai remarqué des changements dans mon énergie au quotidien et dans sa régularité.'
  }
};


var OVERRIDES = {
  'pp|aucun|france,prise': 'Depuis que je prends Post-Partum, je n’ai pas remarqué de changement particulier. J’ai aussi apprécié la prise facile au quotidien et la fabrication française.'
};


function joinFr(arr) {
  if (arr.length <= 1) {
    return arr.join('');
  }
  return arr.slice(0, -1).join(', ') + ' et ' + arr[arr.length - 1];
}


function partieA4(appr, sans, avecPremiere) {
  var trio = ['prise', 'composition', 'france']
    .filter(function (k) {
      return appr.indexOf(k) >= 0;
    })
    .map(function (k) {
      return FRAG[k];
    });


  var acc = appr.indexOf('accompagnee') >= 0;
  var reco = appr.indexOf('reco') >= 0;
  var out = [];


  if (avecPremiere) {
    if (trio.length) {
      out.push((sans ? 'J’ai toutefois apprécié ' : 'J’ai aussi apprécié ') + joinFr(trio) + '.');
    }


    if (acc) {
      out.push(
        trio.length
          ? 'J’ai également apprécié de me sentir accompagnée.'
          : (
            sans
              ? 'J’ai toutefois apprécié de me sentir accompagnée.'
              : 'J’ai aussi apprécié de me sentir accompagnée.'
          )
      );
    }


    if (reco) {
      out.push(sans ? 'Je le recommande néanmoins.' : 'Je le recommande.');
    }
  } else {
    if (trio.length) {
      out.push('J’ai apprécié ' + joinFr(trio) + '.');
    }


    if (acc) {
      out.push(
        trio.length
          ? 'J’ai également apprécié de me sentir accompagnée.'
          : 'J’ai apprécié de me sentir accompagnée.'
      );
    }


    if (reco) {
      out.push('Je le recommande.');
    }
  }


  return out;
}


function composeAvis(fam, a2, a3, appr) {
  appr = appr || [];


  if (fam && BASES[fam] && a2) {
    var key = a2 === 'aucun' ? 'aucun' : (a3 ? a2 + '|' + a3 : a2);
    var first = BASES[fam][key];


    if (!first) {
      return '';
    }


    var ov = OVERRIDES[fam + '|' + key + '|' + appr.slice().sort().join(',')];


    if (ov) {
      return ov;
    }


    return [first].concat(partieA4(appr, a2 === 'aucun', true)).join(' ');
  }


  return partieA4(appr, false, false).join(' ');
}


var AUCUN = ['Pas d’amélioration', 'aucun'];


function sAucun(P, first, theme) {
  if (first) {
    return 'Depuis que je prends ' + P + ', je n’ai pas remarqué d’amélioration particulière.';
  }


  return theme
    ? 'Côté ' + theme + ', je n’ai pas remarqué d’amélioration particulière.'
    : 'Je n’ai pas remarqué d’amélioration particulière.';
}


function qSingle(id, label, opts, tpl) {
  return {
    id: id,
    mode: 'single',
    label: label,
    opts: opts.concat([AUCUN]),
    etat: function (sel) {
      return sel[0] === 'aucun' ? 'aucun' : 'pos';
    },
    phrase: function (sel, first, P) {
      if (sel[0] === 'aucun') {
        return sAucun(P, first);
      }


      var o = opts.filter(function (x) {
        return x[1] === sel[0];
      })[0];


      return o ? tpl(P, o[2]) : '';
    }
  };
}


function qMulti(id, label, opts, tpl) {
  return {
    id: id,
    mode: 'multi',
    label: label,
    opts: opts.concat([AUCUN]),
    etat: function (sel) {
      return sel.indexOf('aucun') >= 0 ? 'aucun' : 'pos';
    },
    phrase: function (sel, first, P) {
      if (sel.indexOf('aucun') >= 0) {
        return sAucun(P, first);
      }


      var f = opts
        .filter(function (x) {
          return sel.indexOf(x[1]) >= 0;
        })
        .map(function (x) {
          return x[2];
        });


      return f.length ? tpl(P, joinFr(f)) : '';
    }
  };
}


function qCtx(id, label, opts, tpl) {
  return {
    id: id,
    mode: 'ctx',
    label: label,
    opts: opts.concat([AUCUN]),
    etat: function (sel) {
      return sel.indexOf('aucun') >= 0 ? 'aucun' : 'neutre';
    },
    phrase: function (sel, first, P) {
      var o = opts.filter(function (x) {
        return sel.indexOf(x[1]) >= 0;
      })[0];


      var a = sel.indexOf('aucun') >= 0;


      if (o) {
        return tpl(P, o[2]) + (a ? ' Je n’ai pas remarqué d’amélioration particulière.' : '');
      }


      return a ? sAucun(P, first) : '';
    }
  };
}


var Q_GENERIQUE = qSingle(
  'q1',
  'Comment vous sentez-vous depuis le début de cette cure ?',
  [
    ['Nettement mieux', 'net', 'nettement mieux'],
    ['Un peu mieux', 'peu', 'un peu mieux']
  ],
  function (P, f) {
    return 'Depuis que je prends ' + P + ', je me sens ' + f + '.';
  }
);


var PQ = {
  magnesium: [
    qSingle(
      'q1',
      'Parmi ces signaux, lequel s’est amélioré en premier ?',
      [
        ['Les tensions', 'tensions', 'mes tensions'],
        ['La nervosité', 'nervosite', 'ma nervosité'],
        ['Les crampes', 'crampes', 'mes crampes'],
        ['Le sommeil', 'sommeil', 'mon sommeil']
      ],
      function (P, f) {
        return 'Depuis que je prends ' + P + ', c’est d’abord du côté de ' + f + ' que j’ai remarqué une évolution.';
      }
    )
  ],


  fer: [
    {
      id: 'q1',
      mode: 'single',
      label: 'Comment votre digestion a-t-elle réagi à Fer depuis la prise ?',
      opts: [
        ['Aucun inconfort', 'aucun_inconfort'],
        ['Un léger inconfort au début', 'leger'],
        ['Des inconforts', 'inconforts']
      ],
      etat: function () {
        return 'neutre';
      },
      phrase: function (sel, first, P) {
        var m = {
          aucun_inconfort: [
            'je n’ai ressenti aucun inconfort digestif.',
            'je n’ai ressenti aucun inconfort.'
          ],
          leger: [
            'j’ai ressenti un léger inconfort digestif au début.',
            'j’ai ressenti un léger inconfort au début.'
          ],
          inconforts: [
            'j’ai ressenti des inconforts digestifs.',
            'j’ai ressenti des inconforts.'
          ]
        }[sel[0]];


        return m
          ? (
            first
              ? 'Depuis que je prends ' + P + ', ' + m[0]
              : 'Côté digestion, ' + m[1]
          )
          : '';
      }
    },
    {
      id: 'q2',
      mode: 'single',
      label: 'Votre fatigue a-t-elle évolué ?',
      opts: [
        ['Oui, nettement', 'nette'],
        ['Oui, un peu', 'legere'],
        AUCUN
      ],
      etat: function (sel) {
        return sel[0] === 'aucun' ? 'aucun' : 'pos';
      },
      phrase: function (sel, first, P) {
        if (sel[0] === 'aucun') {
          return first
            ? 'Depuis que je prends ' + P + ', je n’ai pas remarqué d’amélioration de ma fatigue.'
            : sAucun(P, false, 'fatigue');
        }


        var f = {
          nette: 'une nette évolution',
          legere: 'une légère évolution'
        }[sel[0]];


        if (!f) {
          return '';
        }


        return first
          ? 'Depuis que je prends ' + P + ', j’ai remarqué ' + f + ' de ma fatigue.'
          : 'Côté fatigue, j’ai remarqué ' + f + '.';
      }
    }
  ],


  fertilite: [
    qMulti(
      'q1',
      'Quels signes ont le plus évolué ?',
      [
        ['La régularité de mes cycles', 'cycles', 'de la régularité de mes cycles'],
        ['Ma glaire cervicale', 'glaire', 'de ma glaire cervicale'],
        ['Mon ovulation', 'ovulation', 'de mon ovulation']
      ],
      function (P, f) {
        return 'Depuis que je prends ' + P + ', j’ai remarqué une évolution ' + f + '.';
      }
    )
  ],


  onagre: [
    qCtx(
      'q1',
      'Pour quelle raison aviez-vous commencé la cure Onagre ?',
      [
        ['Améliorer ma glaire cervicale', 'glaire', 'améliorer ma glaire cervicale'],
        ['Apaiser une sécheresse intime', 'intime', 'apaiser une sécheresse intime'],
        ['Apaiser une sécheresse cutanée', 'cutanee', 'apaiser une sécheresse cutanée'],
        ['Mieux vivre mon cycle', 'cycle', 'mieux vivre mon cycle']
      ],
      function (P, f) {
        return 'J’ai commencé la cure ' + P + ' pour ' + f + '.';
      }
    )
  ],


  allaitement: [
    qMulti(
      'q1',
      'Entre les tétées, qu’avez-vous observé sur votre production de lait et votre énergie ?',
      [
        ['Ma production de lait', 'lait', 'de ma production de lait'],
        ['Mon énergie', 'energie', 'de mon énergie']
      ],
      function (P, f) {
        return 'Depuis que je prends ' + P + ', j’ai remarqué une évolution ' + f + '.';
      }
    )
  ],


  premenstruel: [
    qSingle(
      'q1',
      'Quelques jours avant vos règles, quel symptôme a le plus évolué ?',
      [
        ['L’humeur', 'humeur', ['c’est', 'mon humeur', 'a']],
        ['L’anxiété', 'anxiete', ['c’est', 'mon anxiété', 'a']],
        ['Les tensions mammaires', 'tensions', ['ce sont', 'mes tensions mammaires', 'ont']],
        ['Les douleurs abdominales', 'douleurs', ['ce sont', 'mes douleurs abdominales', 'ont']]
      ],
      function (P, f) {
        return 'Depuis que je prends ' + P + ', quelques jours avant mes règles, ' + f[0] + ' surtout ' + f[1] + ' qui ' + f[2] + ' évolué.';
      }
    )
  ],


  'omega-3': [
    qCtx(
      'q1',
      'Dans quel contexte avez-vous pris Oméga 3 ?',
      [
        ['Pendant ma grossesse', 'grossesse', 'pendant ma grossesse'],
        ['Pendant l’allaitement', 'allaitement', 'pendant l’allaitement'],
        ['Au quotidien', 'quotidien', 'au quotidien']
      ],
      function (P, f) {
        return 'J’ai pris ' + P + ' ' + f + '.';
      }
    )
  ],


  menopause: [
    qMulti(
      'q1',
      'Parmi ces symptômes, lesquels se sont le plus améliorés ?',
      [
        ['Les bouffées de chaleur', 'bouffees', 'de mes bouffées de chaleur'],
        ['Les sueurs nocturnes', 'sueurs', 'de mes sueurs nocturnes'],
        ['Le brouillard mental', 'brouillard', 'de mon brouillard mental']
      ],
      function (P, f) {
        return 'Depuis que je prends ' + P + ', j’ai remarqué une évolution ' + f + '.';
      }
    )
  ],


  fatigue: [
    qSingle(
      'q1',
      'Comment a évolué votre fatigue depuis le début de cette cure ?',
      [
        ['Une nette évolution', 'nette', 'une nette évolution'],
        ['Une légère évolution', 'legere', 'une légère évolution']
      ],
      function (P, f) {
        return 'Depuis que je prends ' + P + ', j’ai remarqué ' + f + ' de ma fatigue.';
      }
    )
  ],


  zen: [
    qSingle(
      'q1',
      'Face à une situation stressante, avez-vous observé un changement dans votre façon de l’appréhender depuis le début de votre cure ?',
      [
        ['Un changement net', 'net', 'un changement net'],
        ['Un léger changement', 'leger', 'un léger changement']
      ],
      function (P, f) {
        return 'Depuis que je prends ' + P + ', j’ai remarqué ' + f + ' dans ma façon d’appréhender les situations stressantes.';
      }
    )
  ],


  cyclopk: [
    qMulti(
      'q1',
      'Depuis le début de votre cure, quels symptômes ont le plus évolué selon vous ?',
      [
        ['Les boutons', 'boutons', 'de mes boutons'],
        ['La pilosité', 'pilosite', 'de ma pilosité'],
        ['La régularité de mes cycles', 'cycles', 'de la régularité de mes cycles']
      ],
      function (P, f) {
        return 'Depuis que je prends ' + P + ', j’ai remarqué une évolution ' + f + '.';
      }
    )
  ],


  libido: [
    qSingle(
      'q1',
      'Quelle place prend l’intimité aujourd’hui depuis le début de cette cure ?',
      [
        ['Une place plus importante', 'plus', 'une place plus importante'],
        ['Une place un peu plus présente', 'peu', 'une place un peu plus présente']
      ],
      function (P, f) {
        return 'Depuis que je prends ' + P + ', l’intimité prend ' + f + ' dans ma vie.';
      }
    )
  ],


  peau: [
    (function () {
      var q = qMulti(
        'q1',
        'Quels changements avez-vous le plus observés sur votre peau ?',
        [
          ['La souplesse', 'souplesse', ''],
          ['La tonicité', 'tonicite', ''],
          ['Les vergetures', 'vergetures', ''],
          ['La cicatrisation', 'cicatrisation', '']
        ],
        function () {
          return '';
        }
      );


      q.phrase = function (sel, first, P) {
        if (sel.indexOf('aucun') >= 0) {
          return sAucun(P, first);
        }


        var g = [
          ['souplesse', 'de la souplesse'],
          ['tonicite', 'de la tonicité']
        ]
          .filter(function (x) {
            return sel.indexOf(x[0]) >= 0;
          })
          .map(function (x) {
            return x[1];
          });


        var items = g.length ? [joinFr(g) + ' de ma peau'] : [];


        if (sel.indexOf('vergetures') >= 0) {
          items.push('de mes vergetures');
        }


        if (sel.indexOf('cicatrisation') >= 0) {
          items.push('de ma cicatrisation');
        }


        if (!items.length) {
          return '';
        }


        var f = (g.length === 2 && items.length > 1)
          ? items[0] + ', ainsi que ' + joinFr(items.slice(1))
          : joinFr(items);


        return 'Depuis que je prends ' + P + ', j’ai remarqué une évolution ' + f + '.';
      };


      return q;
    })()
  ],


  immunite: [
    qSingle(
      'q1',
      'Comment avez-vous traversé cette période avec Immunité ?',
      [
        ['Nettement mieux que d’habitude', 'net', 'nettement mieux que d’habitude'],
        ['Un peu mieux que d’habitude', 'peu', 'un peu mieux que d’habitude']
      ],
      function (P, f) {
        return 'Avec ' + P + ', j’ai traversé cette période ' + f + '.';
      }
    )
  ],


  sommeil: [
    qMulti(
      'q1',
      'Dans vos nuits, qu’est-ce qui s’est amélioré ?',
      [
        ['Le temps d’endormissement', 'endormissement', 'de mon temps d’endormissement'],
        ['Les réveils nocturnes', 'reveils', 'de mes réveils nocturnes'],
        ['L’état de fatigue au réveil', 'reveil', 'de mon état de fatigue au réveil']
      ],
      function (P, f) {
        return 'Depuis que je prends ' + P + ', j’ai remarqué une évolution ' + f + '.';
      }
    )
  ],


  intime: [
    qMulti(
      'q1',
      'Selon votre histoire personnelle, avez-vous observé une amélioration des symptômes ou une diminution des récurrences ?',
      [
        ['Une amélioration des symptômes', 'symptomes', 'une amélioration de mes symptômes'],
        ['Moins de récurrences', 'recurrences', 'une diminution des récurrences']
      ],
      function (P, f) {
        return 'Depuis que je prends ' + P + ', j’ai observé ' + f + '.';
      }
    )
  ],


  endo: [
    qMulti(
      'q1',
      'Depuis le début de votre cure, qu’avez-vous observé sur votre fatigue et votre bien-être émotionnel au quotidien ?',
      [
        ['Ma fatigue', 'fatigue', 'de ma fatigue'],
        ['Mon bien-être émotionnel', 'emotionnel', 'de mon bien-être émotionnel']
      ],
      function (P, f) {
        return 'Depuis que je prends ' + P + ', j’ai remarqué une évolution ' + f + ' au quotidien.';
      }
    )
  ],


  regles: [
    qSingle(
      'q1',
      'Depuis le début de votre cure, comment a évolué votre rapport à la douleur ?',
      [
        ['Une nette évolution', 'nette', 'une nette évolution'],
        ['Une légère évolution', 'legere', 'une légère évolution']
      ],
      function (P, f) {
        return 'Depuis que je prends ' + P + ', j’ai remarqué ' + f + ' de mon rapport à la douleur pendant mes règles.';
      }
    )
  ],


  biberon: [
    qMulti(
      'q1',
      'Pendant le sevrage ou les engorgements, comment ont évolué la montée de lait et les tensions mammaires ?',
      [
        ['La montée de lait', 'montee', 'de ma montée de lait'],
        ['Les tensions mammaires', 'tensions', 'de mes tensions mammaires']
      ],
      function (P, f) {
        return 'Depuis que je prends ' + P + ', j’ai remarqué une évolution ' + f + '.';
      }
    )
  ]
};


var PQ_ALIAS = {
  'omega-3-vegetal': 'omega-3',
  energie: 'fatigue',
  'zen-copie': 'zen',
  stress: 'zen',
  reves: 'sommeil',
  urinaire: 'intime',
  'stop-allaitement': 'biberon'
};


function questionsProduit(handle, type) {
  if (type === 'pack') {
    return [Q_GENERIQUE];
  }


  var k = PQ_ALIAS[handle] || handle;
  return PQ[k] || [Q_GENERIQUE];
}


function nomDansPhrase(titre, type) {
  return type === 'pack' ? 'le ' + titre : titre;
}


function composeProduit(handle, titre, type, rep, appr) {
  rep = rep || {};
  appr = appr || [];


  var qs = questionsProduit(handle, type);
  var P = nomDansPhrase(titre, type);
  var parts = [];
  var first = true;
  var aucun = false;
  var pos = false;


  qs.forEach(function (q) {
    var sel = rep[q.id] || [];


    if (!sel.length) {
      return;
    }


    var s = q.phrase(sel, first, P);


    if (!s) {
      return;
    }


    parts.push(s);
    first = false;


    var e = q.etat(sel);


    if (e === 'aucun') {
      aucun = true;
    }


    if (e === 'pos') {
      pos = true;
    }
  });


  if (!parts.length) {
    return partieA4(appr, false, false).join(' ');
  }


  return parts.concat(partieA4(appr, aucun && !pos, true)).join(' ');
}


function basculer(q, sel, v) {
  sel = (sel || []).slice();
  var i = sel.indexOf(v);


  if (q.mode === 'single') {
    return i >= 0 ? [] : [v];
  }


  if (q.mode === 'multi') {
    if (i >= 0) {
      sel.splice(i, 1);
      return sel;
    }


    if (v === 'aucun') {
      return ['aucun'];
    }


    return sel.filter(function (x) {
      return x !== 'aucun';
    }).concat([v]);
  }


  if (i >= 0) {
    sel.splice(i, 1);
    return sel;
  }


  if (v === 'aucun') {
    return sel.concat(['aucun']);
  }


  return sel.filter(function (x) {
    return x === 'aucun';
  }).concat([v]);
}


function sansAmelioration(rep) {
  return Object.keys(rep || {}).some(function (k) {
    return (rep[k] || []).indexOf('aucun') >= 0;
  });
}


/* @@GEN-END */


  /* V5.5 : contexte neutre + choix, jamais la question complete. */
  function reponsesBrutes(c) {
    function libelle(opts, val) {
      var match = (opts || []).filter(function (x) { return x[1] === val; })[0];
      return match ? match[0] : '';
    }
    var THEMES = {
      magnesium: ['Zone sur laquelle la cliente dit avoir ressenti une amélioration'],
      fer: ['Tolérance digestive déclarée', 'Ressenti sur la fatigue'],
      fertilite: ['Évolutions ressenties du cycle'],
      onagre: ['Motif de la cure, pas un résultat'],
      allaitement: ['Évolutions ressenties'],
      premenstruel: ['Ressenti avant les règles'],
      'omega-3': ['Contexte de prise, pas un résultat'],
      menopause: ['Symptômes dont la cliente dit avoir remarqué une amélioration'],
      fatigue: ['Ressenti sur la fatigue'],
      zen: ['Ressenti face au stress'],
      cyclopk: ['Changements ressentis'],
      libido: ['Ressenti sur l’intimité'],
      peau: ['Changements observés sur la peau'],
      immunite: ['Ressenti pendant la période'],
      sommeil: ['Changements ressentis dans le sommeil'],
      intime: ['Ressenti sur les symptômes et leur fréquence'],
      endo: ['Ressenti sur la fatigue et les émotions'],
      regles: ['Ressenti sur les douleurs pendant les règles'],
      biberon: ['Changements ressentis pendant le sevrage'],
      generique: ['Ressenti depuis le début de la cure']
    };
    var observations = [];
    if (c.fam) {
      if (c.a2) observations.push({
        contexte: c.fam === 'pp' ? 'Ressenti sur énergie et équilibre émotionnel' : 'Ressenti sur le bien-être et énergie',
        choix: [libelle(A2DEF[c.fam].opts, c.a2)].filter(Boolean)
      });
      if (c.a3 && c.a2 !== 'aucun') observations.push({
        contexte: 'Moment où la cliente dit avoir ressenti ce changement',
        choix: [libelle(A3DEF.opts, c.a3)].filter(Boolean)
      });
    } else {
      var k = cleQuestionnaire(c.handle, c.type);
      var themes = THEMES[k] || THEMES.generique;
      questionsProduit(c.handle, c.type).forEach(function (q, i) {
        var vals = (c.rep[q.id] || []).map(function (v) { return libelle(q.opts, v); }).filter(Boolean);
        if (vals.length) observations.push({
          contexte: themes[i] || themes[0],
          choix: vals
        });
      });
    }
    return {
      observations: observations,
      points_apprecies: c.appr.map(function (v) { return libelle(APPR.opts, v); }).filter(Boolean),
      ressenti_personnel: String(c.ressentiCure || '').trim()
    };
  }

  function texteCarte(c) {
    return c.fam
      ? composeAvis(c.fam, c.a2, c.a3, c.appr)
      : composeProduit(c.handle, c.titre, c.type, c.rep, c.appr);
  }


  function cleQuestionnaire(handle, type) {
    if (type === 'pack') {
      return 'generique';
    }


    var k = PQ_ALIAS[handle] || handle;
    return PQ[k] ? k : 'generique';
  }


  /* ========================= 2 · ÉTAPE 2 ========================= */
  var Q = {
    pourqui: {
      label: 'Pour qui avez-vous choisi cette cure ?',
      opts: [
        ['Moi', 'moi'],
        ['Une ou un proche', 'proche']
      ],
      noteProche: 'C’est noté. Nous ne vous poserons pas de questions personnelles sur cette personne.'
    },


    bebe_sem: {
      type: 'number',
      label: 'Quel âge a votre bébé ?',
      prefix: 'Bébé a',
      unit: 'semaines',
      min: 0,
      max: 104,
      ph: '8',
      coeur: 'À 3 semaines ou à 3 mois après l’accouchement, vos besoins ne sont pas les mêmes. L’âge de bébé nous aide à vous accompagner au bon moment.',
      err: 'Indiquez un nombre de semaines entre 0 et 104.'
    },


    allaitement_pp: {
      label: 'Où en êtes-vous avec l’allaitement ?',
      opts: [
        ['Oui', 'en_cours'],
        ['Sevrage en cours', 'sevrage'],
        ['Non', 'non']
      ],
      coeur: 'Certaines plantes sont déconseillées pendant l’allaitement. Le savoir nous permet de vous orienter uniquement vers des formules compatibles.'
    },


    allait_duree: {
      label: 'Jusqu’à quel âge de votre bébé envisagez-vous d’allaiter ?',
      help: 'Une idée suffit, vous pourrez toujours changer d’avis.',
      opts: [
        ['Moins de 3 mois', '0_3'],
        ['3 à 6 mois', '3_6'],
        ['6 à 12 mois', '6_12'],
        ['Plus d’un an', '12_plus'],
        ['Je ne sais pas', 'ne_sait_pas']
      ],
      coeur: 'L’allaitement et le sevrage sont deux étapes différentes. Nous adaptons nos conseils à chacune, selon votre rythme et vos choix.'
    },


    besoin_pp: {
      label: 'Et en ce moment, qu’est-ce qui vous préoccupe le plus ?',
      opts: [
        ['Une fatigue qui ne lâche pas, même quand bébé dort', 'fatigue'],
        ['Un moral fragile, une charge mentale qui déborde', 'moral'],
        ['Des nuits qui ne réparent plus', 'sommeil'],
        ['Des crampes, des tensions musculaires', 'tensions'],
        ['Ma peau et mes cicatrices me préoccupent', 'peau'],
        ['Tout va bien pour le moment', 'aucun']
      ],
      coeur: 'Fatigue, moral, sommeil… chaque femme vit son post-partum différemment. Nous adaptons nos conseils à <em>vos</em> besoins et à votre allaitement.'
    },


    fertilite_statut: {
      label: 'Où en êtes-vous aujourd’hui ?',
      opts: [['Je suis enceinte', 'oui'], ['Pas encore', 'non']],
      coeur: 'Votre réponse nous permet de vous proposer des conseils adaptés à votre situation.'
    },
    fertilite_duree: {
      label: 'Depuis combien de temps essayez-vous ?',
      opts: [['Moins de 6 mois', 'moins_6'], ['6 à 12 mois', '6_12'], ["Plus d’un an", 'plus_12']],
      coeur: 'Question facultative.'
    },
    fertilite_suivi: {
      label: 'Comment suivez-vous votre cycle ?',
      opts: [['Je ne le suis pas', 'aucun'], ['Une application', 'application'], ["Des tests d’ovulation", 'tests_ovulation'], ['La température', 'temperature'], ['Tempdrop', 'tempdrop']],
      coeur: 'Question facultative.'
    },
    sa_sem: {
      type: 'number',
      label: 'À combien de semaines êtes-vous ?',
      prefix: 'Je suis à',
      unit: 'semaines d’aménorrhée (SA)',
      min: 4,
      max: 42,
      ph: '24',
      help: 'Le chiffre de votre suivi de grossesse.',
      coeur: 'Vos besoins évoluent au fil de la grossesse. Connaître votre nombre de SA nous aide à vous accompagner au bon moment, selon votre stade de grossesse.',
      err: 'Indiquez un nombre de semaines entre 4 et 42.'
    },


    allaitement_m9: {
      label: 'Envisagez-vous d’allaiter votre bébé ?',
      help: 'Vous pourrez toujours changer d’avis.',
      opts: [
        ['Oui', 'prevu'],
        ['Non', 'non_prevu'],
        ['Je ne sais pas encore', 'ne_sait_pas']
      ],
      coeur: 'Allaitement ou non, votre choix mérite d’être respecté. Le connaître nous permet de préparer avec vous un accompagnement adapté après la naissance.'
    },


    compl_m9: {
      label: 'Prenez-vous déjà du fer ou des oméga 3 ?',
      opts: [
        ['Fer', 'fer'],
        ['Oméga 3', 'omega3'],
        ['Les deux', 'fer_omega3'],
        ['Aucun', 'aucun']
      ],
      coeur: 'Pendant la grossesse, chaque complément compte. Savoir si vous prenez déjà du fer ou des oméga 3 nous aide à éviter les doublons dans nos conseils.'
    },


    besoin_m9: {
      label: 'Et en ce moment, qu’est-ce qui vous préoccupe le plus ?',
      opts: [
        ['Des nausées qui s’invitent dans mes journées', 'nausees'],
        ['Une fatigue plus lourde que prévu', 'fatigue'],
        ['Des crampes, des tensions, un sommeil agité', 'tensions'],
        ['Ma peau tiraille (vergetures, démangeaisons)', 'peau'],
        ['J’ai l’impression de tomber malade plus facilement', 'defenses'],
        ['Tout va bien pour le moment', 'aucun']
      ],
      coeur: 'Une fatigue persistante et des nausées ne demandent pas le même accompagnement. Nous adaptons nos conseils à vos besoins et à votre stade de grossesse.'
    }
  };


  var SECTIONS = {
    pp: [
      ['Vous et bébé', ['bebe_sem', 'allaitement_pp', 'allait_duree']],
      ['Vos besoins du moment', ['besoin_pp']]
    ],
    pb: [['Votre projet bébé', ['fertilite_statut', 'fertilite_duree', 'fertilite_suivi']]],
    m9: [
      ['Votre grossesse', ['sa_sem', 'compl_m9']],
      ['Vos besoins du moment', ['besoin_m9']]
    ]
  };


  /* ====================== 3 · MICRO-TEXTES ====================== */
  var W = {
    titre: function (p) {
      return p
        ? p + ', <mark>quel regard</mark> portez-vous sur votre cure ?'
        : '<mark>Quel regard</mark> portez-vous sur votre cure ?';
    },
    a1: 'Choisissez le nombre d’étoiles qui reflète votre expérience.',
    noteChoisie: function (n) {
      return 'Votre note : ' + n + ' sur 5';
    },
    a10_1: 'Choisissez une note pour publier votre avis.',
    a10_2: function (p, i) {
      return p
        ? 'Votre avis sera publié sous « ' + p + (i ? ' ' + i + '.' : '') + ' », après vérification.'
        : 'Votre avis sera publié sous votre prénom et l’initiale de votre nom, après vérification.';
    },
    a10_3: 'Choisissez au moins une réponse pour préparer votre avis.',
    a11_titre: function (p) {
      return p ? 'Merci ' + p + ' !' : 'Merci !';
    },
    a11_corps: function (prod) {
      return 'Merci d’avoir partagé votre expérience avec ' + prod + '. Votre avis pourra aider d’autres femmes à faire leur choix en confiance.';
    },
    a11_fin: 'Il sera publié sur la fiche produit après vérification.',
    deja: function (prod) {
      return 'Vous avez déjà partagé votre avis sur ' + prod + '. Merci !';
    },
    produitN: function (i, n) {
      return 'Produit ' + i + ' / ' + n;
    },
    aEvaluer: function (n) {
      return n === 1 ? '1 produit à évaluer' : n + ' produits à évaluer';
    },
    auto: 's’écrit avec vos réponses',
    modifie: 'modifié par vous',
    envoi: 'Publication…',
    erreur: 'Votre avis n’a pas pu être envoyé. Réessayez dans un instant.',
    lienInvalide: 'Ce lien n’est plus valide. Vous pouvez retrouver vos commandes dans votre compte.',
    c4: 'Merci pour votre confiance. Nous tiendrons compte de vos réponses pour adapter nos prochains conseils.',
    c5: 'Aucun souci. Vous pourrez partager ces informations une prochaine fois, si vous le souhaitez.'
  };


  /* =============================== 4 · ÉTAT =============================== */
  var cfg = {
    proxyBase: '/apps/avis',
    etape2: false
  };


  var st = {
    o: '',
    t: '',
    prenom: '',
    initiale: '',
    demo: false,
    lienV3: false,
    cards: [],
    host: null,
    s2: {
      state: '',
      pourqui: '',
      priv: {},
      consent: false
    }
  };


  function $(id) {
    return document.getElementById(id);
  }


  function el(tag, cls, html) {
    var e = document.createElement(tag);


    if (cls) {
      e.className = cls;
    }


    if (html !== undefined) {
      e.innerHTML = html;
    }


    return e;
  }


  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;'
      }[c];
    });
  }


  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 2.4l2.95 6.03 6.65.97-4.8 4.68 1.13 6.62L12 17.57 6.07 20.7l1.13-6.62-4.8-4.68 6.65-.97z"></path></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><polyline points="4 12.5 9.5 18 20 6.5"></polyline></svg>';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.5s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.6a4.3 4.3 0 0 1 7.5 2.7c0 5.6-7.5 10.2-7.5 10.2z"></path></svg>';
  var PEN = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20h9"></path><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"></path></svg>';
  var ALERT = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 6v8"></path><path d="M12 18h.01"></path></svg>';
  var ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h14"></path><path d="M13 6l6 6-6 6"></path></svg>';


  /* Sur mobile : conserver le logo, masquer l'introduction de page. */
  var avisMobileStyle = document.createElement('style');
  avisMobileStyle.textContent = '@media (max-width: 749px) { #va-root .va-hero, #va-root .va-steptop, #va-root .va-progbar { display: none !important; } }';
  document.head.appendChild(avisMobileStyle);

  /* ============================== 5 · RÉSEAU ============================== */
  /* ====== Commandes Shopify via Cloudflare (liens Klaviyo o + e) ====== */
  var WORKER_URL = 'https://hollis-avis-api.curly-bread-1894.workers.dev';

  function apiCloudflare(path, payload) {
    return fetch(WORKER_URL + path, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(Object.assign({
        o: st.o,
        e: st.email
      }, payload || {}))
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || !data || data.ok === false) {
          var error = new Error((data && data.code) || 'HTTP_' + response.status);
          error.code = data && data.code;
          throw error;
        }
        return data;
      });
    });
  }

  function apiIA(body) {
    return fetch(WORKER_URL + '/api/generer', {
      method:'POST', mode:'cors', credentials:'omit',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(body)
    }).then(function(response) {
      return response.json().catch(function() { return null; }).then(function(result) {
        if (!response.ok || !result || result.ok === false) {
          var error = new Error(result && result.code || 'AI_HTTP_' + response.status);
          error.code = result && result.code || 'AI_HTTP_' + response.status;
          error.status = response.status;
          throw error;
        }
        return result;
      });
    });
  }

  function api(path, method, body) {
    if (st.shopifyOrder && !st.demo && path === '/prive') {
      return apiCloudflare('/api/prive', body);
    }
    if (st.shopifyOrder && !st.demo && path === '/avis') {
      return apiCloudflare('/api/avis', body);
    }

    if (st.demo) {
      return new Promise(function (res) {
        setTimeout(function () {
          res({
            ok: true,
            stamped_review_id: 'demo-' + Date.now()
          });
        }, 500);
      });
    }


    var url = cfg.proxyBase + path + (
      method === 'GET'
        ? '?o=' + encodeURIComponent(st.o) + '&t=' + encodeURIComponent(st.t)
        : ''
    );


    return fetch(url, {
      method: method,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: method === 'GET'
        ? undefined
        : JSON.stringify(Object.assign({ o: st.o, t: st.t }, body))
    }).then(function (r) {
      if (!r.ok) {
        throw new Error('HTTP ' + r.status);
      }


      return r.json();
    });
  }


  /* ====================== 6 · HERO + PROGRESSION ====================== */
  function renderHero() {
    $('va-titre').innerHTML = W.titre(esc(st.prenom));
    $('va-count').textContent = W.aEvaluer(st.cards.length);


    var box = $('va-packs');
    box.innerHTML = '';


    st.cards.slice(0, 3).forEach(function (c, i) {
      var d = el('div', 'va-pack va-pack--' + (i + 1));


      d.innerHTML = c.image
        ? '<img src="' + esc(c.image) + '" alt="" loading="lazy">'
        : '';


      box.appendChild(d);
    });
  }


  function renderProgress() {
    var done = st.cards.filter(function (c) {
      return c.status === 'publie' || c.status === 'deja';
    }).length;


    var n = st.cards.length;
    var dots = $('va-prog-dots');
    dots.innerHTML = '';


    st.cards.forEach(function (c) {
      var ok = c.status === 'publie' || c.status === 'deja';
      var d = el('div', 'va-dot' + (ok ? ' va-dot--ok' : ''));


      d.innerHTML = (
        c.image
          ? '<img src="' + esc(c.image) + '" alt="' + esc(c.titre) + '">'
          : ''
      ) + (
        ok
          ? '<span class="va-dot__chk">' + CHECK + '</span>'
          : ''
      );


      dots.appendChild(d);
    });


    $('va-prog-txt').textContent = done + ' / ' + n;
    $('va-prog-bar').style.width = Math.round(done / Math.max(1, n) * 100) + '%';
  }


  /* ========================= 7 · UNE CARTE ========================= */
  function chipRow(opts, isOn, onPick) {
    var row = el('div', 'va-chips');


    opts.forEach(function (o) {
      var b = el('button', 'va-chip');
      b.type = 'button';


      b.innerHTML = '<span class="va-chip__chk">' + CHECK + '</span><span>' + esc(o[0]) + '</span>';


      b.addEventListener('click', function () {
        onPick(o[1]);
      });


      b.__v = o[1];
      row.appendChild(b);
    });


    row.__sync = function () {
      Array.prototype.forEach.call(row.children, function (b) {
        var on = isOn(b.__v);
        b.classList.toggle('va-chip--on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    };


    row.__sync();
    return row;
  }


  function field(label, help) {
    var f = el('fieldset', 'va-field');
    f.appendChild(el('legend', 'va-legend', esc(label)));


    if (help) {
      f.appendChild(el('div', 'va-help', esc(help)));
    }


    return f;
  }


  function renderCard(c, idx) {
    var sec = el('section', 'va-card va-fade');
    sec.style.animationDelay = (idx * 90) + 'ms';
    c.node = sec;


    var head = el('div', 'va-card__head');
    head.style.background = c.tint || '#F8EFEB';


    head.innerHTML = '<div class="va-card__blob"></div><div class="va-card__img">' + (
      c.image
        ? '<img src="' + esc(c.image) + '" alt="Flacon ' + esc(c.titre) + '">'
        : ''
    ) + '</div>' +
      '<div class="va-card__meta"><div class="va-card__pos">' +
      esc(W.produitN(idx + 1, st.cards.length)) +
      '</div><h2>' + esc(c.titre) + '</h2></div>';


    var rate = el('div', 'va-rate');

    // Ligne 1 : valoriser le témoignage avant de demander la note.
    rate.style.display = 'flex';
    rate.style.flexDirection = 'column';
    rate.style.alignItems = 'stretch';
    rate.style.gap = '10px';
    rate.style.width = '100%';

    // Ligne 2 : note obligatoire et étoiles, sans changer leur fonctionnement.
    var ratingRow = el('div', 'va-rate__rating-row');
    ratingRow.style.display = 'flex';
    ratingRow.style.flexDirection = 'column';
    ratingRow.style.alignItems = 'center';
    ratingRow.style.gap = '6px';
    ratingRow.style.width = '100%';

    var ratingQuestion = el(
      'div',
      'va-rate__question',
      'Quelle note donnez-vous à cette cure ?'
    );
    ratingQuestion.style.textAlign = 'center';
    ratingQuestion.style.fontWeight = '600';
    ratingRow.appendChild(ratingQuestion);

    var starsWrap = el('div', 'va-stars-wrap');
    starsWrap.style.justifyContent = 'center';
    var stars = el('div', 'va-stars');


    stars.setAttribute('role', 'group');
    stars.setAttribute('aria-label', 'Votre note sur 5');


    for (var i = 1; i <= 5; i++) {
      (function (n) {
        var b = el('button', 'va-tile', STAR);
        b.type = 'button';
        b.setAttribute('aria-label', 'Donner ' + n + ' sur 5 à ' + c.titre);


        b.addEventListener('click', function () {
          c.note = n;
          c.errNote = false;
          sync();
        });


        stars.appendChild(b);
      })(i);
    }


    starsWrap.appendChild(el('span', 'va-alert', ALERT));
    starsWrap.appendChild(stars);


    var noteHelp = el('div', 'va-rate__help', esc(W.a1));
    noteHelp.setAttribute('aria-live', 'polite');


    ratingRow.appendChild(starsWrap);
    ratingRow.appendChild(noteHelp);
    rate.appendChild(ratingRow);
    head.appendChild(rate);


    var badge = el('div', 'va-done-badge');
    head.appendChild(badge);
    sec.appendChild(head);


    var body = el('div', 'va-card__body');
    sec.appendChild(body);


    var rows = [];
    var fA3 = null;


    if (c.fam) {
      var f2 = field(A2DEF[c.fam].label);


      var r2 = chipRow(
        A2DEF[c.fam].opts,
        function (v) {
          return c.a2 === v;
        },
        function (v) {
          c.a2 = c.a2 === v ? '' : v;


          if (!c.a2 || c.a2 === 'aucun') {
            c.a3 = '';
          }


          sync();
        }
      );


      f2.appendChild(r2);
      body.appendChild(f2);
      rows.push(r2);


      fA3 = field(A3DEF.label);


      var r3 = chipRow(
        A3DEF.opts,
        function (v) {
          return c.a3 === v;
        },
        function (v) {
          c.a3 = c.a3 === v ? '' : v;
          sync();
        }
      );


      fA3.appendChild(r3);
      body.appendChild(fA3);
      rows.push(r3);
    } else {
      questionsProduit(c.handle, c.type).forEach(function (q) {
        var fq = field(q.label);


        var rq = chipRow(
          q.opts,
          function (v) {
            return (c.rep[q.id] || []).indexOf(v) >= 0;
          },
          function (v) {
            c.rep[q.id] = basculer(q, c.rep[q.id], v);
            sync();
          }
        );


        fq.appendChild(rq);
        body.appendChild(fq);
        rows.push(rq);
      });
    }


    var f4 = field(APPR.label, APPR.help);


    var r4 = chipRow(
      APPR.opts,
      function (v) {
        return c.appr.indexOf(v) >= 0;
      },
      function (v) {
        var i = c.appr.indexOf(v);


        if (i >= 0) {
          c.appr.splice(i, 1);
        } else {
          c.appr.push(v);
        }


        sync();
      }
    );


    f4.appendChild(r4);
    body.appendChild(f4);
    rows.push(r4);


    /* V5 - Une reponse personnelle par produit, sans changer les questions existantes. */
    var personalField = field(
      'Si vous deviez retenir une seule chose de votre cure, ce serait quoi ?',
      'Obligatoire · Un détail précis de votre expérience (3 à 180 caractères) : un ressenti, une habitude ou une déception.'
    );
    var personalInput = el('textarea', 'va-personal-input');
    personalInput.rows = 2;
    personalInput.maxLength = 180;
    personalInput.placeholder = 'Ex. : Je pense plus facilement à ma prise chaque matin.';
    personalInput.setAttribute('aria-label', 'Ce que vous retenez de votre cure');
    personalInput.style.cssText = 'width:100%;min-height:96px;max-width:100%;padding:14px 16px;border:1px solid #B8C7D2;border-radius:14px;font:inherit;font-size:16px;line-height:1.6;color:#003F5E;background:#fff;resize:vertical;box-sizing:border-box;';
    var personalError = el('div', 'va-err');
    personalError.hidden = true;
    personalError.textContent = 'Indiquez au moins 3 caractères sur votre expérience de la cure.';
    personalField.appendChild(personalInput);
    personalField.appendChild(personalError);
    body.appendChild(personalField);
    personalInput.addEventListener('input', function () {
      c.ressentiCure = personalInput.value.slice(0, 180);
      if (!c.edited) c.text = '';
      if (!c.titleEdited) c.title = '';
      c.errPersonal = false;
      personalError.hidden = true;
      sync();
    });
    c.personalInput = personalInput;
    c.personalField = personalField;

    /* Titre propose, editable directement, sans bouton supplementaire. */
    var titleWrap = el('div', 'va-ta va-title');
    var titleId = 'va-title-' + c.product_id;
    titleWrap.innerHTML = '<div class="va-ta__top"><label class="va-ta__lbl" for="' +
      esc(titleId) + '">Titre proposé à partir de vos réponses</label></div>' +
      '<input id="' + esc(titleId) + '" type="text" maxlength="180" ' +
      'autocomplete="off" placeholder="Le titre de votre avis" ' +
      'style="display:block;width:100%;box-sizing:border-box;min-height:48px;' +
      'padding:12px 14px;border:1px solid #d4d4d4;border-radius:8px;' +
      'background:#fff;color:inherit;font:inherit;" />' +
      '<div class="va-ta__foot"><span>Ce titre est proposé automatiquement. Vous pouvez le modifier librement.</span></div>';
    body.appendChild(titleWrap);
    var titleInput = titleWrap.querySelector('input');
    titleInput.addEventListener('input', function () {
      c.titleEdited = true;
      c.title = titleInput.value;
      sync();
    });
    c.titleInput = titleInput;

    var taWrap = el('div', 'va-ta');
    var taId = 'va-ta-' + c.product_id;


    taWrap.innerHTML = '<div class="va-ta__top"><label class="va-ta__lbl" for="' +
      taId + '"><span class="va-alert">' + ALERT +
      '</span>Texte proposé à partir de vos réponses</label><span class="va-auto"><span class="va-auto__pen">' +
      PEN + '</span><span class="va-auto__txt"></span></span></div>' +
      '<textarea id="' + taId +
      '" rows="4" placeholder="À partir de vos réponses, nous préparons votre avis ici."></textarea>' +
      '<div class="va-ta__foot"><span>Un détail à ajouter, une nuance à apporter ? Modifiez ce texte librement : c’est votre avis.</span><button type="button" class="va-ghost">Reprendre le texte proposé</button></div>';


    body.appendChild(taWrap);


    var ta = taWrap.querySelector('textarea');
    var resync = taWrap.querySelector('.va-ghost');
    var auto = taWrap.querySelector('.va-auto');
    var autoTxt = taWrap.querySelector('.va-auto__txt');
    var demoGenerationInfo = el('div', 'va-help');
    demoGenerationInfo.setAttribute('role', 'status');
    demoGenerationInfo.style.cssText = 'margin-top:8px;font-size:12px;';
    taWrap.appendChild(demoGenerationInfo);


    ta.addEventListener('input', function () {
      c.edited = true;
      c.text = ta.value;
      sync();
    });


    c.starsWrap = starsWrap;
    c.firstTile = stars.firstChild;
    c.taWrap = taWrap;
    c.ta = ta;


    resync.addEventListener('click', function () {
      if (c.aiStatus === 'error') {
        // Retry only on a deliberate click; preserve anything manually typed.
        c.aiKey = '';
      } else {
        c.edited = false;
        c.titleEdited = false;
      }
      sync();
    });


    var pubWrap = el('div', 'va-pub');
    var pub = el('button', 'va-cta', '<span class="va-cta__lbl">Publier mon avis</span>' + ARROW);
    pub.type = 'button';


    var pubHelp = el('div', 'va-cta-help');
    pubWrap.appendChild(pub);
    pubWrap.appendChild(pubHelp);
    body.appendChild(pubWrap);


    pub.addEventListener('click', function () {
      publish(c);
    });


    var after = el('div', 'va-card__after');
    sec.appendChild(after);


    // Claude is primary. Local generation remains an invisible fallback.
    function scheduleAI(composed) {
      if (c.status !== 'avis') return;
      var personal = String(c.ressentiCure || '').trim();
      var eligible = c.note > 0 && composed && composed.length >= 12 && personal.length >= 3;
      var key = eligible ? JSON.stringify([c.note, reponsesBrutes(c), c.titre]) : '';
      if (key === c.aiKey) return;

      clearTimeout(c.aiTimer);
      c.aiSerial += 1;
      var serial = c.aiSerial;
      c.aiKey = key;
      c.aiTitle = '';
      c.aiText = '';
      c.aiStatus = eligible ? 'loading' : 'idle';

      if (!eligible) return;
      // En demonstration aussi, appeler Claude pour tester la vraie reformulation.
      // /api/generer est sans effet sur Stamped et reste limite cote Worker.

      c.aiTimer = setTimeout(function () {
        apiIA({
          produit: c.titre,
          note: c.note,
          ressenti_cure: personal,
          reponses_brutes: reponsesBrutes(c),
          texte_source: composed // Secours ancien Worker V5 uniquement
        })
          .then(function (result) {
            if (serial !== c.aiSerial || c.status !== 'avis') return;
            var title = String(result && result.titre || '').trim();
            var text = String(result && result.texte || '').trim();
            if (!result || !result.ok || !title || !text) throw new Error('IA incomplete');
            c.aiTitle = title;
            c.aiText = text;
            c.aiError = '';
            c.aiStatus = 'ready';
            c.sync();
          })
          .catch(function (error) {
            if (serial !== c.aiSerial || c.status !== 'avis') return;
            // No fake draft: the required free-text answer is INPUT, not a generated review.
            // In case of failure, the customer can retry or write the review manually.
            c.aiTitle = '';
            c.aiText = '';
            c.aiError = String(error && error.code || 'AI_UNAVAILABLE');
            c.aiStatus = 'error';
            c.sync();
          });
      }, 1100);
    }

    function sync() {
      Array.prototype.forEach.call(stars.children, function (b, i) {
        b.classList.toggle('va-tile--on', c.note >= i + 1);
        b.setAttribute('aria-pressed', c.note === i + 1 ? 'true' : 'false');
      });


      noteHelp.textContent = c.note ? W.noteChoisie(c.note) : W.a1;


      rows.forEach(function (r) {
        r.__sync();
      });


      if (fA3) {
        fA3.style.display = (c.a2 && c.a2 !== 'aucun') ? '' : 'none';
      }


      var composed = texteCarte(c);
      scheduleAI(composed);
      personalError.hidden = !c.errPersonal;

      // Avoid showing rule-based suggestions before Claude responds.
      var hasProposal = c.aiStatus === 'ready';
      if (!c.titleEdited) {
        c.title = hasProposal ? c.aiTitle : '';
        if (titleInput.value !== c.title) titleInput.value = c.title;
      }
      if (!c.edited) {
        c.text = hasProposal ? c.aiText : '';
        if (ta.value !== c.text) ta.value = c.text;
      }
      titleInput.placeholder = c.aiStatus === 'loading'
        ? 'Nous préparons votre titre…' : 'Le titre de votre avis';
      ta.placeholder = c.aiStatus === 'loading'
        ? 'Nous préparons votre avis…'
        : (c.aiStatus === 'error' ? 'Vous pouvez écrire votre propre avis ou réessayer la génération.' : 'À partir de vos réponses, nous préparons votre avis ici.');

      var has = ta.value.trim().length > 0;


      if (has) {
        c.errText = false;
      }


      ta.classList.toggle('va-ta--auto', !c.edited && has);
      auto.style.display = has ? '' : 'none';
      autoTxt.textContent = c.edited ? W.modifie : W.auto;


      resync.style.display = c.aiStatus === 'error' || (c.edited && c.aiText && ta.value !== c.aiText)
        ? '' : 'none';
      resync.textContent = c.aiStatus === 'error' ? 'Réessayer la génération' : 'Reprendre le texte proposé';
      demoGenerationInfo.style.display = st.demo || c.aiStatus === 'error' ? '' : 'none';
      if (c.aiStatus === 'error') {
        var tooMany = c.aiError === 'RATE_LIMITED' || c.aiError === 'CLAUDE_PROVIDER_RATE_LIMITED';
        var message = tooMany
          ? 'La génération a atteint sa limite de demandes. Réessayez plus tard.'
          : 'La génération automatique n’a pas abouti. Réessayez.';
        demoGenerationInfo.textContent = message + ' Vous pouvez aussi rédiger votre titre et votre avis librement.' +
          (st.demo ? ' (Diagnostic : ' + c.aiError + ')' : '');
      } else if (st.demo) {
        demoGenerationInfo.textContent = c.aiStatus === 'ready'
          ? 'Démo : ce brouillon provient de Claude.'
          : (c.aiStatus === 'loading' ? 'Démo : génération Claude en cours…' : 'Démo : complétez les réponses pour générer.');
      }


      var ok = c.note > 0 && String(c.ressentiCure || '').trim().length >= 3 && has && !!String(c.title || '').trim() && c.status === 'avis';


      pub.disabled = !!c.sending || st.lienV3;
      pub.classList.toggle('va-cta--off', !ok);
      pub.setAttribute('aria-disabled', ok ? 'false' : 'true');


      rate.classList.toggle('va-rate--err', !!c.errNote);
      noteHelp.classList.toggle('va-rate__help--err', !!c.errNote);
      taWrap.classList.toggle('va-ta--err', !!c.errText);
      titleInput.style.borderColor = c.errText && !String(c.title || '').trim() ? '#c34b3b' : '#d4d4d4';


      pub.querySelector('.va-cta__lbl').textContent = c.sending
        ? W.envoi
        : 'Publier mon avis';


      pubHelp.textContent = c.error
        ? W.erreur
        : (!c.note ? W.a10_1 : (has ? W.a10_2(st.prenom, st.initiale) : W.a10_3));


      pubHelp.classList.toggle('va-cta-help--err', !!(c.error || c.errNote || c.errText));


      var closed = c.status !== 'avis';
      rate.style.display = closed ? 'none' : '';
      body.style.display = closed ? 'none' : '';
      badge.style.display = c.status === 'publie' ? 'flex' : 'none';


      if (c.status === 'publie') {
        badge.innerHTML = '<span class="va-done-badge__chk">' + CHECK +
          '</span><span class="va-mini">' +
          [1, 2, 3, 4, 5].map(function (n) {
            return '<i class="' + (c.note >= n ? 'on' : '') + '">' + STAR + '</i>';
          }).join('') +
          '</span>';
      }
    }


    c.sync = sync;
    c.after = after;


    sync();


    if (c.status === 'deja') {
      renderDeja(c);
    }


    return sec;
  }


  function renderDeja(c) {
    c.after.innerHTML = '<div class="va-deja"><span class="va-deja__chk">' +
      CHECK + '</span><span>' + esc(W.deja(c.titre)) + '</span></div>';
  }


  function renderMerci(c) {
    c.after.innerHTML = '<div class="va-merci va-fade"><div class="va-merci__ico va-pop">' +
      CHECK + '</div><div><h3>' + esc(W.a11_titre(st.prenom)) +
      '</h3><p>' + esc(W.a11_corps(c.titre)) +
      '</p><p>' + esc(W.a11_fin) + '</p></div></div>';
  }


  /* ========================= 8 · PUBLICATION ========================= */
  function secouer(node) {
    node.classList.remove('va-shake');
    void node.offsetWidth;
    node.classList.add('va-shake');
  }


  /* Titre d'avis adapte a l'experience reelle, sans inventer un benefice. */
  function titreAvis(c) {
    var texte = String(c.edited ? c.text : texteCarte(c)).toLowerCase();
    var aucun = c.fam ? c.a2 === 'aucun' : sansAmelioration(c.rep);
    if (aucun || /pas remarqu[eé] (d.am[eé]lioration|de changement)|aucune am[eé]lioration|pas de changement/.test(texte)) {
      return 'Pas de changement remarqué pour le moment';
    }
    var qualif = c.note >= 4 ? 'Une évolution' : 'Mon ressenti';
    if (c.fam === 'm9') {
      if (c.a2 === 'energie') return qualif + ' de mon énergie';
      if (c.a2 === 'regularite') return qualif + ' de la regularite de mon énergie';
      if (c.a2 === 'deux') return qualif + ' au quotidien';
    }
    if (c.fam === 'pp') {
      if (c.a2 === 'energie') return qualif + ' de mon énergie';
      if (c.a2 === 'emotion') return qualif + ' de mon équilibre émotionnel';
      if (c.a2 === 'deux') return qualif + ' de mon bien-être';
    }
    if (c.note === 5) return 'Très satisfaite de cette cure';
    if (c.note === 4) return 'Une bonne expérience';
    if (c.note === 3) return 'Mon expérience avec cette cure';
    if (c.note === 2) return 'Une expérience mitigée';
    return "Cette cure ne m'a pas convaincue";
  }

  function publish(c) {
    if (st.lienV3) {
      c.error = true;
      c.sync();
      return;
    }
    if (c.sending || c.status !== 'avis') {
      return;
    }


    var composed = texteCarte(c);
    var txt = String(c.text || '').trim();


    if (!c.note || String(c.ressentiCure || '').trim().length < 3 || !txt || !String(c.title || '').trim()) {
      c.errPersonal = String(c.ressentiCure || '').trim().length < 3;
      c.errNote = !c.note;
      c.errText = !txt || !String(c.title || '').trim();
      c.sync();


      var cible = c.errNote ? c.starsWrap : (c.errPersonal ? c.personalField : (!String(c.title || '').trim() ? c.titleInput : c.taWrap));
      secouer(cible);


      var doux = !(
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );


      if (cible.scrollIntoView) {
        cible.scrollIntoView({
          behavior: doux ? 'smooth' : 'auto',
          block: 'center'
        });
      }


      var f = c.errNote ? c.firstTile : (c.errPersonal ? c.personalInput : (!String(c.title || '').trim() ? c.titleInput : c.ta));


      if (f && f.focus) {
        try {
          f.focus({ preventScroll: true });
        } catch (e) {
          f.focus();
        }
      }


      return;
    }


    var payload = {
      product_id: c.product_id,
      variant_id: c.variant_id,
      produit_handle: c.handle,
      produit: c.titre,
      produit_type: c.type,
      questionnaire: c.fam || cleQuestionnaire(c.handle, c.type),
      note: c.note,
      avis_titre: String(c.title || '').trim(),
      reponse_1: c.fam
        ? (c.a2 ? [c.a2] : [])
        : (c.rep.q1 || []).slice(),
      reponse_2: c.fam
        ? []
        : (c.rep.q2 || []).slice(),
      temporalite: c.fam ? (c.a3 || '') : '',
      sans_amelioration: c.fam
        ? c.a2 === 'aucun'
        : sansAmelioration(c.rep),
      avis_apprecie: c.appr.slice(),
      ressenti_cure: String(c.ressentiCure || '').trim().slice(0, 180),
      avis_texte: txt,
      avis_texte_source: c.edited
        ? (composed ? 'propose_modifie' : 'libre')
        : 'propose',
      position: c.position,
      nb_produits: st.cards.length,
      version_questionnaire: 'V5',
      source: 'page_votre_avis'
    };


    c.sending = true;
    c.error = false;
    c.sync();


    api('/avis', 'POST', payload).then(function (res) {
      c.sending = false;


      if (!res || !res.ok) {
        throw new Error('refus');
      }


      c.status = res.deja ? 'deja' : 'publie';
      c.stamped_review_id = res.stamped_review_id || null;


      c.sync();
      renderProgress();


      if (c.status === 'deja') {
        renderDeja(c);
        return;
      }


      renderMerci(c);


      if (cfg.etape2 && c.parcours && !step2Sent(c.parcours)) {
        renderStep2(c);
      }
    }).catch(function () {
      c.sending = false;
      c.error = true;
      c.sync();
    });
  }


  /* ============================ 9 · ÉTAPE 2 ============================ */
  function renderStep2(c) {
    if (c.step2Rendered || step2Sent(c.parcours)) return;
    c.step2Rendered = true;
    // Isolate private responses between Pregnancy and Post-Partum.
    var s2 = c.privateState = { state: '', pourqui: '', priv: {}, consent: false };
    var fam = c.parcours;
    var wrap = el('div', 'va-step2 va-fade');


    wrap.innerHTML = '<div class="va-intro"><div class="va-intro__blob"></div>' +
      '<div class="va-intro__kicker">Étape 2 · Facultative · Vos réponses restent privées</div>' +
      '<h3>Pour la suite, des conseils qui tiennent compte de votre réalité</h3>' +
      '<p>Grossesse, naissance, post-partum : chaque étape mérite une attention particulière. Dites-nous où vous en êtes pour que nous puissions mieux comprendre vos besoins.</p>' +
      '<p><strong>À votre rythme :</strong> chaque question est facultative.</p>' +
      '<p><strong>Entre nous :</strong> vos réponses ne sont jamais publiées.</p>' +
      '<p><strong>Avec exigence :</strong> nos conseils s’appuient sur l’expertise de notre équipe scientifique et les recommandations de santé en vigueur.</p></div>';


    var form = el('div', 'va-priv');
    wrap.appendChild(form);


    var syncs = [];
    var f0 = field(Q.pourqui.label);


    var r0 = chipRow(
      Q.pourqui.opts,
      function (v) {
        return s2.pourqui === v;
      },
      function (v) {
        s2.pourqui = s2.pourqui === v ? '' : v;
        s2sync();
      }
    );


    f0.appendChild(r0);
    form.appendChild(f0);
    syncs.push(r0.__sync);


    var noteP = el('div', 'va-note-info', esc(Q.pourqui.noteProche));
    form.appendChild(noteP);


    var qs = el('div', 'va-priv__qs');
    form.appendChild(qs);


    var q3 = null;
    var fertilityFields = {};


    SECTIONS[fam].forEach(function (sec) {
      qs.appendChild(
        el('div', 'va-sep', '<span>' + esc(sec[0]) + '</span><i></i>')
      );


      sec[1].forEach(function (qid) {
        var q = Q[qid];
        var f;


        if (q.type === 'number') {
          f = el('div', 'va-field');


          f.innerHTML = '<label class="va-legend" for="va-' + qid + '">' +
            esc(q.label) + '</label><div class="va-coeur">' +
            HEART + '<span>' + q.coeur + '</span></div>' +
            '<div class="va-numrow"><span>' + esc(q.prefix) +
            '</span><input id="va-' + qid +
            '" type="number" inputmode="numeric" min="' + q.min +
            '" max="' + q.max + '" step="1" placeholder="' + q.ph +
            '"><span>' + esc(q.unit) + '</span></div>' +
            (
              q.help
                ? '<div class="va-help va-help--after">' + esc(q.help) + '</div>'
                : ''
            ) +
            '<div class="va-err" hidden>' + esc(q.err) + '</div>';


          var inp = f.querySelector('input');
          var err = f.querySelector('.va-err');


          inp.addEventListener('input', function () {
            s2.priv[qid] = inp.value;


            var n = parseInt(inp.value, 10);


            err.hidden = !(
              inp.value !== '' &&
              (isNaN(n) || n < q.min || n > q.max)
            );
          });
        } else {
          f = field(q.label);


          var co = el(
            'div',
            'va-coeur',
            HEART + '<span>' + q.coeur + '</span>'
          );


          f.appendChild(co);


          if (q.help) {
            f.appendChild(el('div', 'va-help', esc(q.help)));
          }


          var r = chipRow(
            q.opts,
            function (v) {
              return s2.priv[qid] === v;
            },
            function (v) {
              s2.priv[qid] = s2.priv[qid] === v ? '' : v;
              s2sync();
            }
          );


          f.appendChild(r);
          syncs.push(r.__sync);
        }


        qs.appendChild(f);


        if (fam === 'pb') fertilityFields[qid] = f;

        if (qid === 'allait_duree') {
          q3 = f;
        }
      });
    });


    var cons = el('div', 'va-consent');


    cons.innerHTML = '<label><input type="checkbox" id="va-consent-' + c.parcours + '"><span>J’accepte que le Laboratoire Hollis conserve mes réponses concernant mon projet bébé, ma grossesse, mon post-partum, mon allaitement et mes besoins afin de personnaliser ses conseils et ses e-mails. Je peux retirer mon consentement à tout moment. <a href="' +
      esc(cfg.urlPolitique || '/policies/privacy-policy') +
      '">Politique de confidentialité</a></span></label>';


    form.appendChild(cons);


    cons.querySelector('input').addEventListener('change', function (e) {
      s2.consent = !!e.target.checked;
    });


    var act = el(
      'div',
      'va-actions',
      '<button type="button" class="va-cta">Envoyer mes réponses</button><button type="button" class="va-skip">Je préfère passer cette étape</button>'
    );


    form.appendChild(act);


    act.querySelector('.va-cta').addEventListener('click', function () {
      sendPrive(c, wrap, false);
    });


    act.querySelector('.va-skip').addEventListener('click', function () {
      finStep2(wrap, true);
    });


    function s2sync() {
      syncs.forEach(function (fn) {
        fn();
      });


      var proche = s2.pourqui === 'proche';


      noteP.style.display = proche ? '' : 'none';
      qs.style.display = proche ? 'none' : '';


      if (fam === 'pb') {
        var pregnant = s2.priv.fertilite_statut === 'oui';
        var trying = s2.priv.fertilite_statut === 'non';
        if (fertilityFields.fertilite_duree) fertilityFields.fertilite_duree.style.display = trying ? '' : 'none';
        if (fertilityFields.fertilite_suivi) fertilityFields.fertilite_suivi.style.display = trying ? '' : 'none';
      }
      if (q3) {
        q3.style.display = s2.priv.allaitement_pp === 'en_cours'
          ? ''
          : 'none';
      }
    }


    s2sync();
    c.after.appendChild(wrap);
  }


  function sendPrive(c, wrap, skip) {
    var r = {};
    var p = c.privateState.priv;


    if (c.privateState.pourqui !== 'proche') {
      if (c.parcours === 'pb') {
        var enceinte = p.fertilite_statut || '';
        if (enceinte !== 'oui' && enceinte !== 'non') {
          var statErr = wrap.querySelector('.va-private-error');
          if (!statErr) { statErr = el('div', 'va-private-error'); wrap.querySelector('.va-actions').appendChild(statErr); }
          statErr.textContent = 'Indiquez si vous êtes enceinte ou pas encore, ou passez cette étape.';
          return;
        }
        r = {
          enceinte: enceinte === 'oui',
          duree_essais: enceinte === 'non' ? (p.fertilite_duree || '') : '',
          suivi_cycle_methode: enceinte === 'non' ? (p.fertilite_suivi || '') : ''
        };
      } else r = c.parcours === 'pp'
        ? {
          bebe_semaines: p.bebe_sem || '',
          allaitement: p.allaitement_pp || '',
          allaitement_duree: p.allaitement_pp === 'en_cours'
            ? (p.allait_duree || '')
            : '',
          besoin: p.besoin_pp || ''
        }
        : {
          sa_semaines: p.sa_sem || '',
          complements_pris: p.compl_m9 || '',
          besoin: p.besoin_m9 || ''
        };
    }


    var btn = wrap.querySelector('.va-actions .va-cta');
    if (!c.privateState.consent) {
      var existing = wrap.querySelector('.va-private-error');
      if (!existing) { existing = el('div', 'va-private-error'); wrap.querySelector('.va-consent').appendChild(existing); }
      existing.textContent = 'Cochez la case de consentement pour envoyer vos réponses, ou passez cette étape.';
      return;
    }
    btn.disabled = true;


    api('/prive', 'POST', {
      produit_hote: c.handle,
      product_id: c.product_id,
      questionnaire: c.parcours,
      pour_qui: c.privateState.pourqui || '',
      consentement: c.privateState.consent,
      reponses: r,
      version_questionnaire: 'V4',
      source: 'page_votre_avis'
    }).then(function (res) {
      if (!res || !res.ok) throw new Error('PRIVATE_SEND_FAILED');
      try { localStorage.setItem('va-e2-' + st.o + '-' + c.parcours, 'sent'); } catch (e) {}
      finStep2(wrap, skip);
    }).catch(function () {
      btn.disabled = false;
      var error = wrap.querySelector('.va-private-error');
      if (!error) { error = el('div', 'va-private-error'); wrap.querySelector('.va-actions').appendChild(error); }
      error.textContent = 'L’envoi a échoué. Veuillez réessayer.';
    });
  }


  function finStep2(wrap, skipped) {
    wrap.querySelector('.va-priv').remove();


    wrap.appendChild(
      el(
        'div',
        'va-fini va-fade',
        HEART + '<span>' + esc(skipped ? W.c5 : W.c4) + '</span>'
      )
    );
  }


  /* ============================== 10 · INIT ============================== */
  var DEMO = {
    prenom: 'Camille',
    initiale: 'D',
    produits: [
      {
        product_id: 8653732872515,
        variant_id: 1,
        handle: 'magnesium',
        titre: 'Magnésium',
        image: '',
        famille: null,
        type: 'simple',
        deja_note: false,
        position: 1
      },
      {
        product_id: 6877008167096,
        variant_id: 2,
        handle: '9-mois',
        titre: '9 Mois',
        image: '',
        famille: 'm9',
        type: 'simple',
        deja_note: false,
        position: 2
      }
    ]
  };


  var TINTS = ['#F8EFEB', '#EBF3FB', '#F4E7DF'];


  function parcoursComplementaire(handle) {
    var parcours = cfg.parcoursComplementaires || {};
    if ((parcours.neufMois || []).indexOf(handle) !== -1) return 'm9';
    if ((parcours.postPartum || []).indexOf(handle) !== -1) return 'pp';
    if ((parcours.fertilite || []).indexOf(handle) !== -1) return 'pb';
    return null;
  }


  function step2Sent(parcours) {
    if (!parcours) return false;
    try {
      // Legacy single-per-order keys belong to the Pregnancy test on this store.
      return localStorage.getItem('va-e2-' + st.o + '-' + parcours) === 'sent' ||
        (parcours === 'm9' && localStorage.getItem('va-e2-' + st.o) === 'sent');
    } catch (e) { return false; }
  }

  function start(data) {
    st.prenom = (data.prenom || '').trim();
    st.initiale = (data.initiale || '').trim().charAt(0).toUpperCase();


    st.cards = (data.produits || []).map(function (p, i) {
      return {
        product_id: p.product_id,
        variant_id: p.variant_id,
        handle: p.handle,
        titre: p.titre,
        image: p.image,
        position: p.position || (i + 1),
        fam: (
          p.type === 'simple' &&
          (p.famille === 'pp' || p.famille === 'm9')
        ) ? p.famille : null,
        parcours: parcoursComplementaire(p.handle),
        tint: p.famille === 'm9'
          ? '#EBF3FB'
          : (p.famille === 'pp' ? '#F8EFEB' : TINTS[i % TINTS.length]),
        type: p.type === 'pack' ? 'pack' : 'simple',
        status: p.deja_note ? 'deja' : 'avis',
        note: 0,
        title: '',
        titleEdited: false,
        aiKey: '', aiSerial: 0, aiTimer: null, aiTitle: '', aiText: '', aiStatus: 'idle', aiError: '',
        a2: '',
        a3: '',
        rep: {},
        appr: [],
        ressentiCure: '',
        errPersonal: false,
        edited: false,
        text: '',
        sending: false,
        error: false,
        errNote: false,
        errText: false
      };
    });


    renderHero();


    var list = $('va-cards');
    list.innerHTML = '';


    st.cards.forEach(function (c, i) {
      list.appendChild(renderCard(c, i));
    });


    renderProgress();
    $('va-root').classList.add('va--ready');
    // An eligible review may already be published: offer the private step on return.
    if (cfg.etape2 && st.shopifyOrder) {
      var seen = {};
      st.cards.forEach(function(card) {
        if (!card.parcours || seen[card.parcours] || card.status !== 'deja') return;
        seen[card.parcours] = true;
        if (!step2Sent(card.parcours)) renderStep2(card);
      });
    }
  }



  /* ==================== LIEN KLAVIYO V3 · PREVISUALISATION ==================== */
  /*
   * La lecture du lien est operationnelle, mais sa simple presence ne prouve pas
   * un achat. Les envois restent verrouilles tant que la publication Stamped
   * ne dispose pas d'un controle de commande cote serveur.
   * Les liens o+t historiques restent integres pour les envois existants.
   */
  function ouvrirLienV3() {
    var C = window.VACalculs;
    if (!C || typeof C.lireLien !== 'function') {
      afficherErreurV3('Le module de calculs est introuvable.');
      return;
    }

    var lien = C.lireLien(window.location.search, window.location.hash);
    if (!lien) {
      afficherErreurV3('Le lien Klaviyo est incomplet ou incorrect.');
      return;
    }

    var lignes = C.cartesAAfficher(lien.lignes);
    if (!lignes.length) {
      afficherErreurV3('Aucun produit eligible a un avis dans cette commande.');
      return;
    }

    Promise.all(lignes.map(function (l, index) {
      if (!/^[a-z0-9][a-z0-9-]*$/.test(l.handle)) {
        return Promise.reject(new Error('Handle invalide'));
      }
      return fetch('/products/' + encodeURIComponent(l.handle) + '.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      }).then(function (r) {
        if (!r.ok) throw new Error('Produit inaccessible : ' + l.handle);
        return r.json();
      }).then(function (p) {
        var pack = /^pack-/.test(l.handle);
        return {
          product_id: p.id,
          variant_id: l.variantId,
          handle: p.handle || l.handle,
          titre: p.title,
          image: p.featured_image || '',
          famille: pack ? null : (l.handle === '9-mois' ? 'm9' : (l.handle === 'post-partum' ? 'pp' : null)),
          type: pack ? 'pack' : 'simple',
          deja_note: false,
          position: index + 1
        };
      });
    })).then(function (produits) {
      st.lienV3 = true;
      st.o = lien.commandeId;
      st.lienData = lien;
      start({
        prenom: lien.prenom,
        initiale: lien.nom.charAt(0),
        produits: produits
      });

      var info = document.createElement('div');
      info.className = 'va-invalid';
      info.setAttribute('role', 'status');
      info.textContent = 'Apercu du nouveau lien Klaviyo : les produits et les questions sont charges. La publication est temporairement desactivee pendant la validation Stamped.';
      var container = $('va-cards');
      container.parentNode.insertBefore(info, container);
      st.cards.forEach(function (c) {
        var btn = c.node.querySelector('.va-pub .va-cta');
        if (btn) {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
          btn.title = 'Publication desactivee pendant la migration Stamped';
        }
      });
    }).catch(function (error) {
      console.error('[Votre avis] Chargement des produits impossible', error);
      afficherErreurV3('Impossible de charger les produits de ce lien.');
    });
  }

  function afficherErreurV3(message) {
    $('va-cards').innerHTML = '<div class="va-invalid">' + esc(message) + '</div>';
  }

  /* =============== KLAVIYO o+e : PRODUITS DE LA COMMANDE =============== */
  function ouvrirCommandeShopify() {
    apiCloudflare('/api/commande', {}).then(function (result) {
      var lignes = result.produits || [];
      var vus = Object.create(null);
      var uniques = lignes.filter(function (item) {
        var id = String(item.product_id || '');
        if (!id || !/^[a-z0-9][a-z0-9-]*$/.test(item.handle || '') || vus[id]) {
          return false;
        }
        vus[id] = true;
        return true;
      });

      if (!uniques.length) {
        throw new Error('NO_PRODUCTS');
      }

      return Promise.all(uniques.map(function (item, index) {
        return fetch('/products/' + encodeURIComponent(item.handle) + '.js', {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        }).then(function (response) {
          if (!response.ok) return null;
          return response.json();
        }).catch(function () {
          return null;
        }).then(function (product) {
          var famille = item.type !== 'pack' && item.handle === '9-mois'
            ? 'm9'
            : (item.type !== 'pack' && item.handle === 'post-partum' ? 'pp' : null);

          return {
            product_id: item.product_id,
            variant_id: item.variant_id,
            handle: item.handle,
            titre: item.titre,
            image: product && product.featured_image ? product.featured_image : '',
            famille: famille,
            type: item.type || 'simple',
            deja_note: item.deja_note === true,
            position: index + 1
          };
        });
      }));
    }).then(function (produits) {
      st.shopifyOrder = true;
      st.lienV3 = false;
      start({ prenom: '', initiale: '', produits: produits });
    }).catch(function (error) {
      console.error('[Votre avis] Shopify :', error.code || error.message);
      afficherErreurV3('Impossible de retrouver cette commande. Vérifiez le lien reçu par e-mail.');
    });
  }

  function init() {
    if (!$('va-root')) {
      return;
    }


    cfg = Object.assign(cfg, window.VA_CONFIG || {});


    var qs = new URLSearchParams(window.location.search);


    st.o = qs.get('o') || '';
    st.t = qs.get('t') || '';
    st.email = qs.get('e') || '';
    st.shopifyOrder = false;
    st.demo = cfg.designMode === true || qs.get('demo') === '1';


    if (st.demo) {
      start(cfg.demoData || DEMO);
      return;
    }


    if (st.o && st.email) {
      ouvrirCommandeShopify();
      return;
    }

    if (qs.has('p') && !st.t) {
      ouvrirLienV3();
      return;
    }

    if (!st.o || !st.t) {
      $('va-cards').innerHTML = '<div class="va-invalid">' +
        esc(W.lienInvalide) + '</div>';
      return;
    }


    api('/commande', 'GET').then(function (data) {
      if (!data || !data.produits || !data.produits.length) {
        throw new Error('vide');
      }


      start(data);
    }).catch(function () {
      $('va-cards').innerHTML = '<div class="va-invalid">' +
        esc(W.lienInvalide) + '</div>';
    });
  }


  if (typeof document !== 'undefined' && document.getElementById) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }


  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      composeAvis: composeAvis,
      composeProduit: composeProduit,
      questionsProduit: questionsProduit,
      basculer: basculer,
      sansAmelioration: sansAmelioration,
      cleQuestionnaire: cleQuestionnaire,
      BASES: BASES,
      OVERRIDES: OVERRIDES,
      PQ: PQ,
      PQ_ALIAS: PQ_ALIAS,
      A2DEF: A2DEF,
      APPR: APPR,
      A3DEF: A3DEF,
      Q: Q,
      W: W
    };
  }
})();